import React from 'react'
import styled from 'styled-components'

const Container = styled.ul`
  display: grid;
  margin: 0;
  padding: 0;
  gap: 16px;

  @media only screen and (min-width: 48em) {
    grid-template-columns: repeat(3, 1fr);

    gap: 36px;
  }

  @media only screen and (min-width: 90em) {
    gap: 56px;
  }

  li {
    margin: 0;
    padding: 0;
  }
`

function SummaryCardList({ children }) {
  return <Container>{children}</Container>
}

export default SummaryCardList
